// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"contact-details-form_buttonsContainer__YQIjo","error":"contact-details-form_error__bdsCB"};